import { Component, Input, Output, ViewChild, EventEmitter, ViewContainerRef, OnInit } from '@angular/core';
import { ICellChangedEvent } from './cellValueChanged.event';
import { IColumn } from './column.interface';

@Component( {
    selector: 'app-qty',
    templateUrl: 'qtyEditor.component.html',
    styleUrls: ['qtyEditor.component.css']
})

export class QtyEditorComponent implements OnInit {

    @Input() row: any;
    @Input() col: IColumn;
    @Input() qty: number;
    @Output() qtyChanged = new EventEmitter<ICellChangedEvent>();
    @ViewChild( 'input', { read: ViewContainerRef }) private input;

    callback: Function;
    lostFocus = false;

    takeFocus( callback?: Function ) {
        setTimeout( _ =>
        {
            this.input.element.nativeElement.focus();
            this.input.element.nativeElement.select();
            this.lostFocus = false;
        });
        if (callback) {
            this.callback = callback;
        }
    }

    // getValue() {
    //     return +this.qty;
    // }

    onChanged( e )
    {
        if (this.lostFocus) {
            return;
        }
        
        this.qtyChanged.emit({
                row: this.row,
                col: this.col,
                oldValue: null,
                newValue: +this.qty,
                cancel: null
            } );
    }    
    
    onKeyDown( event: KeyboardEvent ): void {
        if ( !this.isCharAcceptable( event.keyCode ) ) {
            if ( event.preventDefault ) {
                event.preventDefault();
            }
        }

        if (event.key == 'Enter') {
            // then we may not be able to move off the cell, but still want to let other know that the val has changed
            this.lostFocus = true;
            this.qtyChanged.emit({
                row: this.row,
                col: this.col,
                oldValue: null,
                newValue: +this.qty,
                cancel: null
            } );
        }
    }

    private isCharAcceptable( ch ): boolean {
        if ( ch >= 48 && ch <= 57 ) {
            return true;
        }

        if ( ch >= 96 && ch <= 105 ) {
            return true;
        }

        if ( ch == 8 || ch == 46 || ch == 37 || ch == 39 ) {
            return true;
        }
        
        // number keypad
        return false;
    }
    
    ngOnInit(): void {
        this.takeFocus();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/Grid/qtyEditor.component.ts